<template>
  <div class="app">
    <Loading :value="loading"></Loading>

    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs icons divider=">">
          <v-breadcrumbs-item icons router :to='item.path' v-for="item in racourcis" :key="item.text" :disabled="item.disabled">
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br>

        <!-- STATS -->
        <v-container  fluid grid-list-md  v-if="droitAcces.client_index || droitAcces.client_projet_index">
            <v-layout row justify>
                <v-flex md6>
                    <div id="chartClientAll" style="width: 450px; height: 300px"></div>
                </v-flex>
                <v-flex md6>
                    <div id="chartFactureAllClient" style="width: 450px; height: 300px"></div>
                </v-flex>
            </v-layout>
        </v-container>

    <!-- BTN AJOUT -->
    <v-spacer></v-spacer>
    <div class="text-xs-right">
      <v-tooltip top v-if="droitAcces.client_projet_new">
        <v-btn slot="activator" icons color="primary" @click.stop="newClient()" dark>
          Ajouter <v-icon right>add</v-icon>
        </v-btn>
        Ajouter un nouveau client
      </v-tooltip>
    </div>

    <!-- MODAL AJOUT DE CLIENT -->
    <v-dialog v-model="dialogAjout" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark color="primary">
          <v-toolbar-title>
            <span v-if="dialogEdit == false">Ajouter un nouveau client</span>
            <span v-if="dialogEdit != false">Modification du client {{client.libelle}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form ref="formClient" v-model="valid" lazy-validation id="formClient">
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Type de client *</span>
                    <el-select v-on:change="changeType()" v-if="!dialogEdit" v-model="form.type" style="width:100%">
                      <el-option v-for="item in typeRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                    <el-input :readonly="true" v-if="dialogEdit && form.type === 1" :value="'PERSONNE PHYSIQUE'" style="width:100%"></el-input>
                    <el-input :readonly="true" v-if="dialogEdit && form.type === 2" :value="'PERSONNE MORALE'" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <!-- PERSONNE PHYSIQUE -->
              <p align="center" v-if="form.type === 1">
                <v-chip text-color="white" label color="primary" style="font-size:22px; width:100%">
                  PERSONNE PHYSIQUE <v-icon right>user-list</v-icon>
                </v-chip>
              </p>
              <v-layout row v-if="form.type === 1">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Civilité *</span>
                    <el-select v-model="form.civilite" style="width:100%">
                      <el-option v-for="item in civiliteRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Nom *</span>
                    <el-input name="libelle" placeholder="Nom" v-model="form.libelle" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Tèl *</span>
                    <el-input name="contact" placeholder="Tèl" v-model="form.contact" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Fixe</span>
                    <el-input name="fixe" placeholder="Fixe" v-model="form.fixe" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row v-if="form.type === 1">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Adresse postale</span>
                    <el-input name="adresse" placeholder="Adresse postale" v-model="form.adresse" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Genre *</span>
                    <el-select v-model="form.genre" style="width:100%">
                      <el-option v-for="item in genreRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

              <!-- PERSONNE MORALE -->
              <p align="center" v-if="form.type === 2">
                <v-chip text-color="white" label color="info" style="font-size:22px; width:100%">
                  PERSONNE MORALE <v-icon right>user-list</v-icon>
                </v-chip>
              </p>
              <v-layout row v-if="form.type === 2">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Raison sociale *</span>
                    <el-input name="libelle" placeholder="Raison sociale" v-model="form.libelle" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Fixe *</span>
                    <el-input name="fixe" placeholder="Fixe" v-model="form.fixe" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Adresse postale</span>
                    <el-input name="adresse" placeholder="Adresse postale" v-model="form.adresse" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Siège *</span>
                    <el-input name="localisation" placeholder="Siège" v-model="form.localisation" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <p align="center" v-if="form.type === 2">
                <v-chip text-color="white" label color="info" style="font-size:22px; width:100%">
                  Détails sur le gérant <v-icon right>user-list</v-icon>
                </v-chip>
              </p>
              <v-layout row v-if="form.type === 2">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Civilité *</span>
                    <el-select v-model="form.civilite" style="width:100%">
                      <el-option v-for="item in civiliteRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Nom et prénoms *</span>
                    <el-input name="gerant" placeholder="Nom et prénoms" v-model="form.gerant" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Genre *</span>
                    <el-select v-model="form.genre" style="width:100%">
                      <el-option v-for="item in genreRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Contact *</span>
                    <el-input name="contact" placeholder="Contact" v-model="form.contact" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row v-if="form.type === 2">
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de naissance</span>
                    <el-date-picker v-model="form.dateN" name="dateN" id="dateN"
                     value-format="dd-MM-yyyy" type="date" placeholder="Date de naissance"
                      style="width: 100%"></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Lieu de naissance</span>
                    <el-input name="lieuN" placeholder="Lieu de naissance" v-model="form.lieuN" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Situation matrimoniale *</span>
                    <el-select v-model="form.situation" style="width:100%">
                      <el-option v-for="item in situationRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <br>

              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn v-if="!dialogEdit" color="primary" @click.native="submit()">
                  Enregistrer<v-icon left>save</v-icon>
                </v-btn>
                <v-btn v-if="dialogEdit" color="primary" @click.native="submit()">
                  Modifier <v-icon right>edit</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL AJOUT DE FACTURE -->
    <v-dialog v-model="dialogFactureAjout" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark color="primary">
          <v-toolbar-title>
            <span v-if="!dialogEdit">Ajouter une nouvelle facture</span>
            <span v-if="dialogEdit">Modification la facture {{facture.ref}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogFactureAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form ref="formFacture" v-model="valid" lazy-validation id="formFacture">
            <v-container fluid grid-list-md>
              <!-- INFO PROJET -->
              <v-chip text-color="white" label color="primary" style="font-size:20px; width:100%">
                INFORMATION CONCERNANT LE PROJET
              </v-chip>
              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Projet concerné *</span>
                    <el-select v-on:change="changeProjet()" v-if="!dialogEdit" v-model="formFacture.projet"
                     clearable style="width:100%">
                      <el-option v-for="item in listProjet" :label="item.libelle" :value="item.id"
                       :key="item.id">
                      </el-option>
                    </el-select>
                    <el-input :readonly="true" v-if="dialogEdit" :value="projet.libelle" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Chef de projet</span>
                    <el-input :readonly="true" :value="projet.chef" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Prix du marché</span>
                    <el-input :readonly="true" :value="projet.montantEstimatif" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Type de facture</span>
                    <el-input :readonly="true" :value="projet.libelleEtatAvance" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <v-chip text-color="white" label color="primary" style="font-size:20px; width:100%">
                DETAILS CONCERNANT LA FACTURE
              </v-chip>
              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Facture ?</span>
                    <el-select v-if="!dialogEdit" v-model="formFacture.avance" style="width:100%">
                      <el-option v-for="item in avanceRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                    <el-input :readonly="true" v-if="dialogEdit" :value="projet.libelle" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date émission *</span>
                    <el-date-picker v-on:change="valideF()" v-model="formFacture.date" name="date" id="date"
                     value-format="dd-MM-yyyy" type="date" placeholder="Date facture"
                      style="width: 100%"></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date de paiment</span>
                    <el-date-picker v-on:change="valideF()" v-model="formFacture.datePaie" name="datePaie"
                     id="datePaie" value-format="dd-MM-yyyy" type="date" placeholder="Date de paiment"
                      style="width: 100%"></el-date-picker>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Trésorerie</span>
                    <el-select v-on:change="valideF()" v-model="formFacture.caisse" style="width:100%">
                      <el-option v-for="item in listCaisse" :label="item.libelle" :value="item.id"
                       :key="item.id">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md4>
                  <div class="block">
                    <span v-if="projet.etatAvance && formFacture.projet" class="demonstration">Montant avance *</span>
                    <span v-if="!projet.etatAvance" class="demonstration">Montant *</span>
                    <el-input v-on:change="valideF()" v-if="projet.etatAvance && formFacture.projet"
                     name="montantAvance" type="number" v-model="formFacture.montantAvance" :min="0"
                      placeholder="Montant avance" style="width:100%; font-size: 2rem; font-weight: bold;"></el-input>
                    <el-input v-on:change="valideF()" v-if="!projet.etatAvance" v-model="formFacture.montantF"
                     placeholder="Montant" style="width:100%; font-size: 2rem; font-weight: bold;"
                      :readonly="true"></el-input>
                  </div>
                </v-flex>
                 <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Tva</span>
                    <el-input  type="number" @change="calculTotalComm()" :min="1" value="tva"  placeholder="Tva" v-model="formFacture.tva" style="width:100%" :readonly="false"></el-input>

                  <!-- <el-input v-on:change="valideF()"
                  name="tva" type="number" v-model="formFacture.tva" :min="0"
                    placeholder="Tva" style="width:100%; font-size: 2rem; font-weight: bold;"></el-input> -->
                  </div>
                </v-flex>
                 <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Total ttc (FCFA)</span>
                    <el-input   type="number"  :readonly="true" @change="calculTotalComm()" :min="0" :value="this.TotalTtc"  :placeholder="this.TotalTtc" v-model="formFacture.TotalTtc" style="width:100%; font-size: 2rem; font-weight: bold;"></el-input>

                  <!-- <el-input v-on:change="valideF()"
                  name="TotalTtc" :readonly="true"  type="number" v-model="formFacture.TotalTtc" :min="0"
                    placeholder="Montant Ttc" style="width:100%; font-size: 2rem; font-weight: bold;"></el-input> -->
                  </div>
                </v-flex>
              </v-layout>

              <v-chip text-color="white" label color="primary" style="font-size:20px; width:100%">
                TRANSMISSION
              </v-chip>
              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Observation </span>
                    <el-input name="description" type="textarea" v-model="formFacture.description"
                      :rows="3" placeholder="Observation" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Transmettre </span>
                    <el-select v-if="!dialogEdit" v-model="formFacture.etat" style="width:100%">
                      <el-option v-for="item in transRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                    <el-select v-if="dialogEdit && facture.etat === 0" v-model="formFacture.etat" style="width:100%">
                      <el-option v-for="item in transRow" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Mode de transmission </span>
                    <el-select v-if="!dialogEdit" v-model="formFacture.modeTrans" style="width:100%">
                      <el-option v-for="item in ModTransmition" :label="item.label" :value="item.value"
                       :key="item.value">
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <el-upload class="upload-demo" drag action=""
                      :on-preview="handlePreview" :on-remove="handleRemove" name="docsFac[]"
                      :file-list="formFacture.fileList" ref="upload" :auto-upload="false" multiple> <i class="el-icon-upload"></i>
                      <div class="el-upload__text">
                        Déposer les fichiers ici ou <em>cliquez pour envoyer</em>
                      </div>
                      <div class="el-upload__tip" slot="tip">
                        Fichiers jpg/png avec une taille inférieure à 500kb
                      </div>
                    </el-upload>
                  </div>
                </v-flex>
              </v-layout>

              <!-- <div v-if="!formFacture.avance && formFacture.projet">
                <v-chip text-color="white" label color="primary" style="font-size:20px; width:100%">
                  POINT DES TACHES REALISEES
                </v-chip>
                <v-layout row>
                  <v-flex md5>
                    <div class="block">
                      <span class="demonstration">Date de début *</span>
                      <el-date-picker v-on:change="valideF()" v-model="formFacture.dateD" name="dateD" id="dateD"
                      value-format="dd-MM-yyyy" type="date" placeholder="Date de début" style="width: 100%"></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md5>
                    <div class="block">
                      <span class="demonstration">Date de fin *</span>
                      <el-date-picker v-on:change="valideF()" v-model="formFacture.dateF" name="dateF" id="dateF"
                      value-format="dd-MM-yyyy" type="date" placeholder="Date de fin" style="width: 100%"></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <br>
                      <v-btn color="primary" @click.native="search()">
                        Recherche <v-icon right>search</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row v-for="(item, index) in formFacture.search" :key="item.id">
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Tâche</span>
                      <el-input :readonly="true" :value="item.tache" :prop="'item.'+ index+'.tache'"
                       style="width:100%"></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Date R.</span>
                      <el-input :readonly="true" :value="item.date" :prop="'item.'+ index+'.date'"
                       style="width:100%"></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Qte</span>
                      <el-input :readonly="true" :value="item.qte" :prop="'item.'+ index+'.qte'"
                       style="width:100%"></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Prix U.</span>
                      <el-input :readonly="true" :value="item.prixU" :prop="'item.'+ index+'.prixU'"
                       style="width:100%"></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">TOTAL</span>
                      <el-input :readonly="true" :value="item.totalF" :prop="'item.'+ index+'.qte'"
                       style="width:100%"></el-input>
                    </div>
                  </v-flex>
                </v-layout>
              </div> -->
              <br>

              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn v-if="!dialogEdit && valid" color="primary" @click.native="submitFacture()">
                  Ajouter<v-icon left>add</v-icon>
                </v-btn>
                <v-btn v-if="dialogEdit && valid" color="primary" @click.native="submitFacture()">
                  Modifier <v-icon right>edit</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL VALIDER FACTURE -->
    <v-dialog v-model="dialogVaildeFAjout" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark color="green">
          <v-toolbar-title>
            <span>Valider la facture {{facture.ref}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogVaildeFAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form ref="formValideF" lazy-validation id="formValideF">
            <v-container fluid grid-list-md>
              <v-stepper v-model="etape">
                <v-stepper-header>
                  <v-stepper-step step="1" :complete="etape > 1">Validation</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step step="2" :complete="etape > 2">Documents</v-stepper-step>
                </v-stepper-header>

                <v-stepper-items>
                  <v-stepper-content step="1">
                    <v-chip text-color="white" label color="green" style="font-size:20px; width:100%">
                      DETAILS CONCERNANT LA FACTURE
                    </v-chip>
                    <v-layout row>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Projet concerné</span>
                          <el-input :readonly="true" :value="facture.projet" style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Montant</span>
                          <el-input :readonly="true" :value="facture.montantF" style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Type de facture</span>
                          <el-input :readonly="true" :value="facture.type" style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Date</span>
                          <el-input :readonly="true" :value="facture.dateFo" style="width:100%"></el-input>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-chip text-color="white" label color="green" style="font-size:20px; width:100%">
                      VALIDATION
                    </v-chip>

                    <v-layout row>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Bureau de contrôle *</span>
                          <el-select v-model="formValideF.controle" style="width:100%">
                            <el-option v-for="item in valideRow" :label="item.label" :value="item.value"
                            :key="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">
                          <span class="demonstration">Maitre d'ouvrage délegué *</span>
                          <el-select v-model="formValideF.delegue" style="width:100%">
                            <el-option v-for="item in valideRow" :label="item.label" :value="item.value"
                            :key="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                      <v-flex md4>
                        <div class="block">C
                          <span class="demonstration">Maitre d'ouvrage  *</span>
                          <el-select v-model="formValideF.coordination" style="width:100%">
                            <el-option v-for="item in valideRow" :label="item.label" :value="item.value"
                            :key="item.value">
                            </el-option>
                          </el-select>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br>

                    <v-layout>
                      <v-btn icons color="orange" @click="dialogVaildeFAjout = false" dark>
                        Annuler
                        <v-icon right>close</v-icon>
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn :disabled="formValideF.coordination === 0 || formValideF.delegue === 0 ||
                       formValideF.controle === 0"
                        icons color="primary" @click="etape = 2;">
                        Suivant <v-icon right>keyboard_arrow_right</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-stepper-content>

                  <v-stepper-content step="2">
                    <v-layout row>
                      <v-flex md6>
                        <div class="block">
                          <el-upload class="upload-demo" drag action=""
                            :on-preview="handlePreview" :on-remove="handleRemove" name="docs[]"
                            :file-list="formValideF.fileList" ref="upload" :auto-upload="false" multiple> <i class="el-icon-upload"></i>
                            <div class="el-upload__text">
                              Déposer les fichiers ici ou <em>cliquez pour envoyer</em>
                            </div>
                            <div class="el-upload__tip" slot="tip">
                              Fichiers jpg/png avec une taille inférieure à 500kb
                            </div>
                          </el-upload>
                        </div>
                      </v-flex>
                      <v-flex md6>
                        <div class="block">
                          <span class="demonstration">Observation </span>
                          <el-input type="textarea" placeholder="Observation" :rows="5" name="description"
                            v-model="formValideF.description" style="width:100%"></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <br>

                    <v-layout>
                      <v-spacer></v-spacer>
                      <v-btn icons color="primary" @click="etape = 1;">
                        <v-icon right>keyboard_arrow_left</v-icon> Précédent
                      </v-btn>
                      <v-btn icons color="primary" @click="submitValideF()">
                        Ajouter <v-icon right>add</v-icon>
                      </v-btn>
                    </v-layout>
                  </v-stepper-content>
                </v-stepper-items>

              </v-stepper>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL DE VALIDATION DU PRECESSUS -->
    <v-dialog v-model="dialogValidePAjout" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark color="lime">
          <v-toolbar-title>
            <span>Processus de validation de la facture {{facture.ref}}</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogValidePAjout = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form ref="formProcessus" v-model="valid" lazy-validation id="formProcessus">
            <v-container fluid grid-list-md>
              <v-chip v-if="!facture.etatPross" text-color="white" label color="red"
               style="font-size:20px; width:100%">
                VEUILLEZ TERMINER LE PRECEDENT PROCESSUS DE ENTAMME.
              </v-chip>
              <!-- INFO FACTURE -->
              <v-chip text-color="white" label color="lime" style="font-size:20px; width:100%">
                DETAILS CONCERNANT LA FACTURE
              </v-chip>
              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Projet concerné</span>
                    <el-input :readonly="true" :value="facture.projet" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Montant</span>
                    <el-input :readonly="true" :value="facture.montantF" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Type de facture</span>
                    <el-input :readonly="true" :value="facture.type" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Date</span>
                    <el-input :readonly="true" :value="facture.dateFo" style="width:100%"></el-input>
                  </div>
                </v-flex>
              </v-layout>

              <!-- FORMULAIRE DE VALIDATION -->
              <div v-if="facture.etatPross || dialogEdit">
                <v-chip text-color="white" label color="lime" style="font-size:20px; width:100%">
                  DETAILS CONCERNANT LA FACTURE
                </v-chip>
                <v-layout row>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Entité concerné *</span>
                      <el-input v-model="formProcess.entite" name="entite" style="width:100%"></el-input>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Mode de transmision *</span>
                      <el-select v-model="formProcess.mode" style="width:100%">
                        <el-option v-for="item in modeRow" :label="item.label" :value="item.value"
                        :key="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Date de transmission *</span>
                      <el-date-picker v-model="formProcess.date" name="date" id="date"
                      value-format="dd-MM-yyyy" type="date" placeholder="Date"
                        style="width: 100%"></el-date-picker>
                    </div>
                  </v-flex>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Etat</span>
                      <el-select v-model="formProcess.etat" style="width:100%">
                        <el-option v-for="item in etatRow" :label="item.label" :value="item.value"
                        :key="item.value">
                        </el-option>
                      </el-select>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row>
                  <v-flex md6>
                    <div class="block">
                      <span class="demonstration">Accusé de réception *</span>
                      <el-upload class="upload-demo" drag action="" :on-preview="handlePreview"
                      :on-remove="handleRemove" name="docsOptFac[]" :file-list="formProcess.fileList"
                        ref="upload" :auto-upload="false" multiple> <i class="el-icon-upload"></i>
                        <div class="el-upload__text">
                          Déposer les fichiers ici ou <em>cliquez pour envoyer</em>
                        </div>
                        <div class="el-upload__tip" slot="tip">
                          Fichiers jpg/png avec une taille inférieure à 500kb
                        </div>
                      </el-upload>
                    </div>
                  </v-flex>
                  <v-flex md6>
                    <div class="block">
                      <span class="demonstration">Description *</span>
                      <el-input type="textarea" v-model="formProcess.description" name="description"
                      style="width:100%"></el-input>
                    </div>
                  </v-flex>
                </v-layout>
                <br>
              </div>

              <!-- BOUTTON AJOUT ET MODIF -->
              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn v-if="dialogEdit" text-color="white" label color="orange" @click.native="annulerPross()" dark>
                  Annuler <v-icon left>close</v-icon>
                </v-btn>
                <v-btn v-if="dialogEdit" color="primary" @click.native="submitProcess()">
                  Modifier <v-icon left>edit</v-icon>
                </v-btn>
                <v-btn v-if="!dialogEdit && facture.etatPross" color="primary" @click.native="submitProcess()">
                  Ajouter <v-icon left>add</v-icon>
                </v-btn>
              </v-layout>

              <!-- LISTE DU PROCESSUS -->
              <v-chip text-color="white" label color="lime" style="font-size:20px; width:100%">
                PROCESSUS
              </v-chip>
              <v-card-text>
                <data-tables :data="listOptions" style="width: 100%">
                  <el-table-column label="" type="expand" fixed="left">
                    <!-- DETAILS DES OPTIONS -->
                    <template slot-scope="scope">
                      <v-layout row justify>
                        <v-flex md6>
                          <p>Description : {{scope.row.description}}</p>
                          <p><b>Enrégistré par : </b> {{scope.row.userCreate}} </p>
                          <p><b>Modifié par : </b> {{scope.row.userUpdate}} </p>
                          <p><b>Date d'enrégistrement : </b> {{scope.row.created}} </p>
                          <p><b>Date de modification : </b> {{scope.row.modified}} </p>
                        </v-flex>
                        <v-flex md6>
                          <el-row :gutter="20">
                            <el-col v-for="fit in scope.row.files" :key="fit.id" :span="6">
                              <a :href="fit.url" target="_blank">{{ fit.img }}</a>
                              <img style="width: 100px; height: 100px" :src="fit.url"/>
                            </el-col>
                          </el-row>
                        </v-flex>
                      </v-layout>
                    </template>
                  </el-table-column>
                  <el-table-column prop="entite" label="Entité" width="200">
                    <template slot-scope="scope">
                      <v-chip text-color="white" label color="primary">
                        {{scope.row.entite}}
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="dateF" label="Date">
                    <template slot-scope="scope">
                      <v-chip text-color="white" label color="primary">
                        {{scope.row.dateF}}
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="mode" label="Mode">
                    <template slot-scope="scope">
                      <v-chip text-color="white" label color="teal">
                        {{scope.row.mode}}
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column prop="etat" label="Etat">
                    <template slot-scope="scope">
                      <v-chip v-if="!scope.row.etat" text-color="white" label color="blue">
                        EN COURS DE TRAITEMENT
                      </v-chip>
                      <v-chip v-if="scope.row.etat" text-color="white" label color="green">
                        TERMINE
                      </v-chip>
                    </template>
                  </el-table-column>
                  <el-table-column label="Action" fixed="right">
                    <template slot-scope="scope">
                      <div class="text-xs-center">
                        <v-tooltip top>
                          <v-btn v-if="!scope.row.etat" slot="activator" @click.stop="editProcess(scope.row);"
                           fab dark small color="blue">
                            <v-icon dark>edit</v-icon>
                          </v-btn>
                          Modifier
                        </v-tooltip>
                        <v-tooltip top>
                          <v-btn v-if="!scope.row.etat" slot="activator" @click.stop="dialogValidePSupr = true;
                           idOpFac = scope.row.id;" fab dark small color="red">
                            <v-icon dark>delete</v-icon>
                          </v-btn>
                          Supprimer
                        </v-tooltip>
                      </div>
                    </template>
                  </el-table-column>
                </data-tables>
              </v-card-text>
              <br>

              <v-layout row>
                <v-spacer></v-spacer>
                <v-btn v-if="facture.etatPross" @click.stop="sumbitClose();" color="lime" dark>
                  Terminer et clore <v-icon left>close</v-icon>
                </v-btn>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW CLIENT -->
    <v-dialog v-model="dialogShow" fullscreen :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails du client {{client.libelle}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content" style=" padding: 3px">
              <el-row>
                <el-tabs v-model="tab" type="border-card">
                  <!-- FICHE CLIENT -->
                  <el-tab-pane name="fiche">
                    <span slot="label"><v-icon right>ic_person</v-icon> Fiche</span>
                    <div class="grid-content bg-purple">
                      <div class="text item">
                        <v-layout row justify>
                          <v-flex md4>
                            <p><b>Réference : </b> {{client.ref}} </p>
                            <p><b>Nom et prénoms / Raison sociale : </b> {{client.libelle}} </p>
                            <p><b>Type de client : </b>
                              <v-chip v-if="client.type == 1" outline text-color="orange" label color="orange">
                                PERSONNE PARTICULIER
                              </v-chip>
                              <v-chip v-if="client.type == 2" outline text-color="indigo" label color="indigo">
                                PERSONNE ENTREPRISE
                              </v-chip>
                            </p>
                            <p v-if="client.type == 1"><b>Tèl : </b> {{client.contact}} </p>
                            <p v-if="client.type == 1"><b>Fixe : </b> {{client.fixe}} </p>
                            <p v-if="client.type == 2"><b>Fixe du gérant : </b> {{client.fixe}} </p>
                            <p v-if="client.type == 2"><b>Contact du gérant : </b> {{client.contact}} </p>
                          </v-flex>
                          <v-flex md4>
                            <p v-if="client.type == 2"><b>Nom et prénoms du gérant : </b> {{client.gerant}} </p>
                            <!-- <p v-if="client.type == 1"><b>Domicile : </b> {{client.localisation}} </p> -->
                            <p v-if="client.type == 2"><b>Siège : </b> {{client.localisation}} </p>
                            <p><b>Adresse postale : </b> {{client.adresse}}</p>
                            <p v-if="client.type == 1"><b>Genre : </b> {{client.genre}}</p>
                            <p v-if="client.type == 2"><b>Genre du gérant : </b> {{client.genre}}</p>

                          </v-flex>
                          <v-flex md4>
                            <!-- <p><b>Lieu de naissance : </b> {{client.lieuN}} </p> -->
                            <!-- <p v-if="client.type == 1"><b>Situation matrimoniale : </b> {{client.situation}} </p> -->
                            <p v-if="client.type == 2"><b>Date de naissance : </b> {{client.dateN}} </p>
                            <p v-if="client.type == 2"><b>Situation matrimoniale du gérant : </b> {{client.situation}} </p>
                            <p><b>Date d'enrégistrement : </b> {{client.created}} </p>
                            <p><b>Date de modification : </b> {{client.modified}} </p>
                          </v-flex>
                        </v-layout>
                      </div>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES FACTURES -->
                  <el-tab-pane name="facture">
                    <span slot="label"><v-icon right>description</v-icon> Factures</span>
                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES FACTURES <v-icon right>description</v-icon>
                      </v-chip>
                            <!-- STATS -->
                            <v-container  fluid grid-list-md>
                                <v-layout row justify>
                                    <v-flex md6>
                                        <div id="chartForOneClient" style="width: 450px; height: 300px"></div>
                                    </v-flex>
                                    <v-flex md6>
                                        <div id="chartFactureForOneClient" style="width: 450px; height: 300px"></div>
                                    </v-flex>
                                </v-layout>
                            </v-container>


                      <!-- BTN AJOUT -->
                      <v-spacer></v-spacer>
                      <div class="text-xs-right">
                        <v-tooltip top>
                          <v-btn slot="activator" icons color="primary" @click.stop="newFacture([])" dark>
                            Ajouter <v-icon right>add</v-icon>
                          </v-btn>
                          Ajouter une nouvelle facture
                        </v-tooltip>
                      </div>
                        <div
                            class="grid-content"
                            style="padding:3px; margin:5px"
                          >
                            <el-row>
                              <v-container fluid grid-list-md>
                                <el-card class="box-card">
                                  <v-form
                                    v-model="valid"
                                    ref="formSearchProjet"
                                    lazy-validation
                                    id="formSearchProjet"
                                  >
                                    <v-layout row>
                                      <v-flex md6>
                                        <el-select
                                          filterable
                                          clearable
                                          v-model="selectSearchProjet"
                                          placeholder="Type de recherche"
                                          style="width:100%"
                                        >
                                           <el-option
                                            v-for="item in listProjet"
                                            :key="item.id"
                                            :label="item.libelle"
                                            :value="item.id"
                                            ></el-option>
                                        </el-select>
                                      </v-flex>

                                      <v-flex md1>
                                        <v-btn icons color="blue" @click="loadProjetFacture(selectSearchProjet)" fab dark small>
                                          <v-icon>search</v-icon>
                                        </v-btn>
                                      </v-flex>
                                    </v-layout>
                                  </v-form>
                                </el-card>
                              </v-container>
                            </el-row>
                        </div>
                      <v-card-text>
                        <data-tables :data="listProjetDetails" style="width: 100%">
                          <el-table-column label="" width="40" fixed="left" type="expand">
                            <template slot-scope="scope">
                              <!-- LISTE DES OPTIONS DU PROCESS EN SOUS TABLEAU -->
                              <data-tables :data="scope.row.options" style="width: 100%">
                                <el-table-column label="" type="expand" fixed="left">
                                  <!-- DETAILS DES OPTIONS -->
                                  <template slot-scope="scope">
                                    <v-layout row justify>
                                      <v-flex md6>
                                        <p>Description : {{scope.row.description}}</p>
                                        <p><b>Enrégistré par : </b> {{scope.row.userCreate}} </p>
                                        <p><b>Modifié par : </b> {{scope.row.userUpdate}} </p>
                                        <p><b>Date d'enrégistrement : </b> {{scope.row.created}} </p>
                                        <p><b>Date de modification : </b> {{scope.row.modified}} </p>
                                      </v-flex>
                                      <v-flex md6>
                                        <el-row :gutter="20">
                                          <el-col v-for="fit in scope.row.files" :key="fit.id" :span="6">
                                            <a :href="fit.url" target="_blank">{{ fit.img }}</a>
                                            <img style="width: 100px; height: 100px" :src="fit.url"/>
                                          </el-col>
                                        </el-row>
                                      </v-flex>
                                    </v-layout>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="entite" label="Entité" width="200">
                                  <template slot-scope="scope">
                                    <v-chip text-color="white" label color="primary">
                                      {{scope.row.entite}}
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="dateF" label="Date">
                                  <template slot-scope="scope">
                                    <v-chip text-color="white" label color="primary">
                                      {{scope.row.dateF}}
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="mode" label="Mode">
                                  <template slot-scope="scope">
                                    <v-chip text-color="white" label color="teal">
                                      {{scope.row.mode}}
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column prop="etat" label="Etat">
                                  <template slot-scope="scope">
                                    <v-chip v-if="!scope.row.etat" text-color="white" label color="blue">
                                      EN COURS DE TRAITEMENT
                                    </v-chip>
                                    <v-chip v-if="scope.row.etat" text-color="white" label color="green">
                                      TERMINE
                                    </v-chip>
                                  </template>
                                </el-table-column>
                                <el-table-column label="Action" fixed="right">
                                  <template slot-scope="scope">
                                    <div class="text-xs-center">
                                      <v-tooltip top>
                                        <v-btn v-if="!scope.row.etat" slot="activator" @click.stop="dialogValidePSupr = true;
                                        idOpFac = scope.row.id;" fab dark small color="red">
                                          <v-icon dark>delete</v-icon>
                                        </v-btn>
                                        Supprimer
                                      </v-tooltip>
                                    </div>
                                  </template>
                                </el-table-column>
                              </data-tables>
                            </template>
                          </el-table-column>
                          <el-table-column prop="ref" label="Réf" width="110">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{scope.row.ref}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="projet" label="Projet concerné">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">
                                {{scope.row.projet}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="avance" label="Type de facture">
                            <template slot-scope="scope">
                              <v-chip v-if="scope.row.avance" text-color="white" label color="blue">
                                FACTURE AVANCE
                              </v-chip>
                              <v-chip v-if="!scope.row.avance" text-color="white" label color="indigo">
                                FACTURE
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="montantF" label="Montant">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="orange">
                                {{scope.row.montantF}} FCFA
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="tva" label="Tva">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="orange">
                                {{scope.row.tva}} %
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="totalTtc" label="Montant ttc">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="orange">
                                {{scope.row.totalTtc}} FCFA
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="etat" label="Etat">
                            <template slot-scope="scope">
                              <v-chip v-if="scope.row.etat === 0" text-color="white" label color="blue">
                                {{scope.row.etatlibelle}}
                              </v-chip>
                              <v-chip v-if="scope.row.etat === 1" text-color="white" label color="orange">
                                {{scope.row.etatlibelle}}
                              </v-chip>
                              <v-chip v-if="scope.row.etat === 2" text-color="white" label color="cyan">
                                {{scope.row.etatlibelle}}
                              </v-chip>
                              <v-chip v-if="scope.row.etat === 3" text-color="white" label color="green">
                                {{scope.row.etatlibelle}}
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column label="Action" fixed="right">
                            <template slot-scope="scope">
                              <div class="text-xs-center">
                                <v-tooltip top>
                                  <v-btn slot="activator" @click.stop="showFacture(scope.row);" fab dark small
                                   color="green">
                                    <v-icon dark>folder_open</v-icon>
                                  </v-btn>
                                  Détails
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn v-if="scope.row.etat === 0" slot="activator"
                                   @click.stop="newFacture(scope.row)" fab dark small color="blue">
                                    <v-icon dark>edit</v-icon>
                                  </v-btn>
                                  Modifier
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn v-if="scope.row.etat === 1" slot="activator"
                                   @click.stop="newProcess(scope.row); loadOption(scope.row)" fab dark small color="lime">
                                    <v-icon dark>timeline</v-icon>
                                  </v-btn>
                                  Processus de validation
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn v-if="scope.row.etat === 2" slot="activator"
                                   @click.stop="valideFacture(scope.row)" fab dark small color="green">
                                    <v-icon dark>done_all</v-icon>
                                  </v-btn>
                                  Valider
                                </v-tooltip>
                                <v-tooltip top>
                                  <v-btn v-if="scope.row.delete" slot="activator" @click.stop="dialogFactureSupr = true; idFacture = scope.row.id;" fab dark small color="red">
                                    <v-icon dark>delete</v-icon>
                                  </v-btn>
                                  Supprimer
                                </v-tooltip>
                              </div>
                            </template>
                          </el-table-column>
                        </data-tables>
                      </v-card-text>
                    </div>
                  </el-tab-pane>
                  <!-- LISTE DES PROJETS -->
                  <el-tab-pane name="projet">
                    <span slot="label"><v-icon right>terrain</v-icon> Projets</span>
                    <div>
                      <v-chip text-color="white" label color="primary">
                        LISTE DES PROJETS <v-icon right>terrain</v-icon>
                      </v-chip>

                      <v-card-text>
                        <data-tables :data="listProjet" style="width: 100%">
                          <el-table-column prop="libelle" label="Libellé" width="370" fixed="left">
                            <template slot-scope="scope">
                              <v-chip text-color="white" label color="primary">{{scope.row.libelle}}</v-chip>
                              <v-chip outline text-color="primary" label color="primary">
                                {{scope.row.adresse}}
                                <v-icon right>location_on</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="type" label="Type de projet">
                            <template slot-scope="scope">
                              <v-chip v-if="scope.row.type" outline text-color="orange" label color="orange">
                                {{scope.row.type}}
                                <v-icon right>business</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="chef" label="Chef de projet">
                            <template slot-scope="scope">
                              <v-chip outline text-color="indigo" label color="indigo">
                                {{scope.row.chef}}
                                <v-icon right>person</v-icon>
                              </v-chip>
                            </template>
                          </el-table-column>
                          <el-table-column prop="evolution" label="Evolution">
                            <template slot-scope="scope">
                              <v-progress-circular
                                :size="85"
                                :width="15"
                                :rotate="360"
                                :value="scope.row.evolution"
                                color="primary"
                              >{{ scope.row.evolutionNbr }} %</v-progress-circular>
                            </template>
                          </el-table-column>
                          <!--el-table-column label="Action" fixed="right">
                            <template slot-scope="scope">
                              <div class="text-xs-center">
                                <v-tooltip top>
                                  <v-btn
                                    slot="activator"
                                    v-if="droitAcces.show_projet"
                                    @click.stop=" tab= '0';showProjet(scope.row);"
                                    fab
                                    dark
                                    small
                                    color="green"
                                  >
                                    <v-badge color="red">
                                      <span v-if="scope.row.nbChantier == 0" slot="badge">!</span>
                                      <v-icon dark>folder_open</v-icon>
                                    </v-badge>
                                  </v-btn>
                                      Détails
                                </v-tooltip>
                              </div>
                            </template>
                          </el-table-column-->
                        </data-tables>
                      </v-card-text>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </el-row>
            </div>
            <br/>
          </el-row>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange" @click.stop="dialogShow = false" dark>Fermer <v-icon right>close</v-icon></v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn slot="activator"  icons color="primary" @click.stop="edit(client);" dark>Modifier <v-icon right>edit</v-icon></v-btn>
            Modifier
          </v-tooltip>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW DE LA FACTURE -->
    <v-dialog v-model="dialogFactureShow" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark color="primary">
          <v-toolbar-title>
            <span>Fiche de la facture {{facture.ref}} </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogFactureShow = false" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- INFO FACTURE -->
            <el-row :gutter="20" style="padding:3px;">
              <el-card class="box-card">
                <div class="grid-content" style="padding:3px;">
                  <el-row>
                    <div class="text item">
                      <v-layout row justify>
                        <v-flex md4>
                          <p> <b>Référence : </b> {{facture.ref}} </p>
                          <p> <b>Projet concerné : </b> {{facture.projet}} </p>
                          <p> <b>Date de la facture : </b> {{facture.dateFo}} </p>
                          <p> <b>Date de paiement : </b> {{facture.datePaieF}} </p>
                          <p> <b>Caisse concerné : </b> {{facture.caisse}} </p>
                          <p v-if="!facture.avance"> <b>Date de début : </b> {{facture.dateDF}} </p>
                          <p v-if="!facture.avance"> <b>Date de fin :</b> {{facture.dateFF}} </p>
                          <p v-if="facture.etat === 1"> <b>Transmit par : </b> {{facture.transmiPar}} </p>
                        </v-flex>
                        <v-flex md4>
                          <p v-if="facture.etat === 2"> <b>Date de cloture : </b> {{facture.dateCloreF}} </p>
                          <p v-if="facture.etat === 2"> <b>Clore par : </b> {{facture.clorePar}} </p>
                          <p v-if="!facture.avance"> <b>Durée :</b> {{facture.duree}} Jour(s) </p>
                          <p>
                            <b>Type de facture : </b>
                            <v-chip v-if="facture.avance === false" text-color="white" label color="indigo">
                              FACTURE
                            </v-chip>
                            <v-chip v-else-if="facture.avance === true" text-color="white" label color="blue">
                              FACTURE AVANCE
                            </v-chip>
                          </p>
                          <p>
                            <b>Statut : </b>
                            <v-chip v-if="facture.etat === 0" text-color="white" label color="green">
                              {{facture.etatlibelle}}
                            </v-chip>
                            <v-chip v-else-if="facture.etat === 1" text-color="white" label color="green">
                              {{facture.etatlibelle}}
                            </v-chip>
                            <v-chip v-else-if="facture.etat === 2" text-color="white" label color="cyan">
                              {{facture.etatlibelle}}
                            </v-chip>
                            <v-chip v-else-if="facture.etat === 3" text-color="white" label color="green">
                              {{facture.etatlibelle}}
                            </v-chip>
                          </p>
                          <p>
                            <b>Etat : </b>
                            <v-chip v-if="facture.etatG === 0" text-color="white" label color="red">
                              IMPAYE
                            </v-chip>
                            <v-chip v-if="facture.etatG === 1" text-color="white" label color="green">
                              SOLDE
                            </v-chip>
                            <v-chip v-if="facture.etatG === 3" text-color="white" label color="orange">
                              EN COURS DE PAIEMENT
                            </v-chip><v-chip v-if="facture.etatG === 2" text-color="white" label color="primary">
                              EN ATTENTE DE PAIEMENT
                            </v-chip>
                          </p>
                          <p v-if="facture.avance"> <b>Montant avance : </b>
                            <v-chip text-color="white" label color="orange">
                              {{facture.montantAvanceF}} FCFA
                            </v-chip>
                          </p>
                           <p > <b>Tva : </b>
                            <v-chip text-color="white" label color="orange">
                              {{facture.tva}} %
                            </v-chip>
                          </p>
                          <p > <b>Montant ttc : </b>
                            <v-chip text-color="white" label color="orange">
                              {{facture.totalTtc}} FCFA
                            </v-chip>
                          </p>
                        </v-flex>
                        <v-flex md4>
                          <p v-if="!facture.avance"> <b>Montant : </b>
                            <v-chip text-color="white" label color="orange" style="width:100%">
                              {{facture.montantF}} FCFA
                            </v-chip>
                          </p>
                          <p> <b>Mode de transmission : </b> {{facture.transmission}} </p>
                          <p> <b>Observation : </b> {{facture.description}} </p>
                          <p> <b>Enrégistré par : </b> {{facture.userCreate}} </p>
                          <p> <b>Dernière modification par : </b> {{facture.userUpdate}} </p>
                          <p> <b>Date d'enrégistrement : </b> {{facture.created}} </p>
                          <p> <b>Dernière modification  :</b> {{facture.modified}} </p>
                        </v-flex>
                      </v-layout>

                      <v-layout row justify>
                        <v-flex md6>
                          <v-chip text-color="white" label color="blue" style="width: 100%">
                            PIECE JOINTE DE LA FACTURE ET ATTACHEMENT
                          </v-chip>
                          <el-row :gutter="20">
                            <el-col v-for="fit in facture.files" :key="fit.id" :span="6">
                              <a :href="fit.url" target="_blank">{{ fit.img }}</a>
                              <img style="width: 100px; height: 100px" :src="fit.url"/>
                            </el-col>
                          </el-row>
                        </v-flex>
                        <v-flex md6>
                          <v-chip text-color="white" label color="blue" style="width: 100%">
                            PIECE JOINTE DE LA FACTURE VALIDE
                          </v-chip>
                          <el-row :gutter="20">
                            <el-col v-for="fit in facture.docsFact" :key="fit.id" :span="6">
                              <a :href="fit.url" target="_blank">{{ fit.img }}</a>
                              <img style="width: 100px; height: 100px" :src="fit.url"/>
                            </el-col>
                          </el-row>
                        </v-flex>
                      </v-layout>
                    </div>
                  </el-row>

                  <el-row v-if="facture.totalRapport > 0">
                    <v-chip text-color="white" label color="primary" style="font-size:20px; width:100%">
                      POINT DES TACHES REALISEES
                    </v-chip>

                    <v-layout row v-for="(item, index) in facture.rapport" :key="item.id">
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Tâche</span>
                          <el-input :readonly="true" :value="item.tache" :prop="'item.'+ index+'.tache'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Date R.</span>
                          <el-input :readonly="true" :value="item.date" :prop="'item.'+ index+'.date'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Qte</span>
                          <el-input :readonly="true" :value="item.qte" :prop="'item.'+ index+'.qte'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Prix U.</span>
                          <el-input :readonly="true" :value="item.prixU" :prop="'item.'+ index+'.prixU'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">TOTAL</span>
                          <el-input :readonly="true" :value="item.totalF" :prop="'item.'+ index+'.total'"
                          style="width:100%; font-weight: bold;"></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md3></v-flex>
                      <v-flex md3></v-flex>
                      <v-flex md3></v-flex>
                      <v-flex md3></v-flex>
                      <v-flex md3>
                        <div class="block">
                          <el-input :readonly="true" :value="totalRapportF+' FCFA'"
                           style="width:100%; font-size: 1.5rem; font-weight: bold;"></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                  </el-row>

                  <el-row >
                    <v-chip text-color="white" label color="primary" style="font-size:20px; width:100%">
                      LISTE DES REGLEMENTS EFFECTUEES
                    </v-chip>

                    <v-layout row v-for="(item, index) in facture.rapport" :key="item.id">
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Tâche</span>
                          <el-input :readonly="true" :value="item.tache" :prop="'item.'+ index+'.tache'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Date R.</span>
                          <el-input :readonly="true" :value="item.date" :prop="'item.'+ index+'.date'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Qte</span>
                          <el-input :readonly="true" :value="item.qte" :prop="'item.'+ index+'.qte'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">Prix U.</span>
                          <el-input :readonly="true" :value="item.prixU" :prop="'item.'+ index+'.prixU'"
                          style="width:100%"></el-input>
                        </div>
                      </v-flex>
                      <v-flex md3>
                        <div class="block">
                          <span class="demonstration">TOTAL</span>
                          <el-input :readonly="true" :value="item.totalF" :prop="'item.'+ index+'.total'"
                          style="width:100%; font-weight: bold;"></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex md3></v-flex>
                      <v-flex md3></v-flex>
                      <v-flex md3></v-flex>
                      <v-flex md3></v-flex>
                      <v-flex md3>
                        <div class="block">
                          <el-input :readonly="true" :value="totalRapportF+' FCFA'"
                           style="width:100%; font-size: 1.5rem; font-weight: bold;"></el-input>
                        </div>
                      </v-flex>
                    </v-layout>
                  </el-row>
                </div>
              </el-card>
            </el-row>
          </v-container>

          <v-tooltip top>
            <v-btn slot="activator" icons color="orange"
             @click.stop="dialogFactureShow = false" dark>Fermer <v-icon right>close</v-icon>
            </v-btn>
            Fermer
          </v-tooltip>
          <v-tooltip top>
            <v-btn v-if="facture.etat === 0" slot="activator" icons color="primary"
             @click.stop="newFacture(facture);" dark>Modifier <v-icon right>edit</v-icon>
            </v-btn>
            Modifier
          </v-tooltip>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION CLIENT -->
    <v-dialog v-model="dialogSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">Voulez-vous vraiment supprimer cet enrégistrement ?</h4>
          <p align="center">
            <v-btn @click.native="dialogSupr = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteC()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION FACTURE -->
    <v-dialog v-model="dialogFactureSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">Voulez-vous vraiment supprimer cet enrégistrement ?</h4>
          <p align="center">
            <v-btn @click.native="dialogFactureSupr = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteF()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION OPTION FACTURE -->
    <v-dialog v-model="dialogValidePSupr" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h4 align="center">Voulez-vous vraiment supprimer cet enrégistrement ?</h4>
          <p align="center">
            <v-btn @click.native="dialogValidePSupr = false" color="orange" dark>
              Annuler
              <v-icon right>close</v-icon>
            </v-btn>
            <v-btn icons color="red" @click.stop="deleteOF()" dark>
              Supprimer
              <v-icon right>delete</v-icon>
            </v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- TABLEAU -->
    <v-card>
      <div>
        <v-chip text-color="white" label color="primary">
          LISTE DES CLIENTS <v-icon right>emoji_people</v-icon>
        </v-chip>
        <v-spacer></v-spacer>

        <v-card-text>
          <data-tables :data="listClient" style="width: 100%" v-if="droitAcces.client_index || droitAcces.client_projet_index">
            <el-table-column prop="libelle" label="Nom et prénoms / Raison sociale" width="370" fixed="left">
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{scope.row.libelle}}
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="type" label="Type de client">
              <template slot-scope="scope">
                <v-chip v-if="scope.row.type == 1" outline text-color="orange" label color="orange">
                  PERSONNE PARTICULIER
                </v-chip>
                <v-chip v-if="scope.row.type == 2" outline text-color="indigo" label color="indigo">
                  PERSONNE ENTREPRISE
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column prop="contact" label="Contact">
              <template slot-scope="scope">
                <v-chip text-color="white" label color="primary">
                  {{scope.row.contact }} <v-icon right>local_phone</v-icon>
                </v-chip>
              </template>
            </el-table-column>
            <el-table-column label="Action" fixed="right">
              <template slot-scope="scope">
                <div class="text-xs-center">
                  <v-tooltip top>
                    <v-btn slot="activator" @click.stop="show(scope.row);loadProjet(scope.row);
                    loadFacture(scope.row)" fab dark small color="green">
                      <v-icon dark>folder_open</v-icon>
                    </v-btn>
                    Détails
                  </v-tooltip>
                  <v-tooltip top v-if="droitAcces.client_projet_edit">
                    <v-btn  slot="activator" @click.stop="edit(scope.row)" fab dark small color="blue">
                      <v-icon dark>edit</v-icon>
                    </v-btn>
                    Modifier
                  </v-tooltip >
                  <v-tooltip top v-if="droitAcces.delete_client_projet">
                    <v-btn v-if="scope.row.delete" slot="activator" @click.stop="dialogSupr = true; idClient = scope.row.id;" fab dark small color="red">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </div>
              </template>
            </el-table-column>
          </data-tables>
        </v-card-text>
      </div>
    </v-card>

  </div>
</template>

<script>
  import Loading from '@/components/Loading';
  var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')


  export default {
    components:{ Loading },
    name: 'app',
    data () {
      return {
        loading: false,
        domaine: JSON.parse(sessionStorage.getItem('sessionDomaine')),
        user: JSON.parse(sessionStorage.getItem('userInfo')),
        roleAcces: JSON.parse(sessionStorage.getItem('sessionAcces')),
        droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
        racourcis: [
          { path: '/', text: 'Accueil', disabled: false },
          { path: '/client', text: 'Liste des clients', disabled: true }
        ],
        dialogAjout: false,
        dialogFactureAjout: false,
        dialogVaildeFAjout: false,
        dialogValidePAjout: false,
        dialogEdit: false,
        dialogShow: false,
        dialogFactureShow: false,
        dialogSupr: false,
        dialogFactureSupr: false,
        dialogValidePSupr: false,
        statAllFactureClient: [],
        statDetailClientForOne: [],
        valid: false,
        listClient: [],
        idClient: '',
        client: [],
        form: {
          type: 1,
          libelle: '',
          genre: '',
          situation: '',
          contact: '',
          fixe: '',
          localisation: '',
          adresse: '',
          dateN: '',
          lieuN: '',
          gerant: ''
        },
        typeRow: [
          {label: 'PERSONNE PHYSIQUE', value: 1},
          {label: 'PERSONNE MORALE', value: 2}
        ],
        civiliteRow: [
          {label: 'MONSIEUR', value: 'Mr'},
          {label: 'MADAME', value: 'Mme'},
          {label: 'MADEMOISELLE', value: 'Mlle'}
        ],
        genreRow: [
          {label: 'MASCULIN', value: 'M'},
          {label: 'FEMININ', value: 'F'}
        ],
        situationRow: [
          {label: 'CELIBATAIRE', value: 'Célibataire'},
          {label: 'MARIE', value: 'Marié'}
        ],
        tab: 'facture',
        listFacture: [],
        formFacture: {
          id: '',
          date: '',
          avance: 1,
          datePaie: '',
          montant: 0,
          montantF: '0',
          montantAvance: 0,
          etat: 0,
          caisse: '',
          description: '',
          statsPieFacture: '',
          statsPieFactureForOne: '',
          projet: '',
          dateD: '',
          dateF: '',
          search: [],
          fileList: [{
            name: '',
            url: ''
          }]
        },
        listProjet: [],
        userDetails:"",
        listProjetDetails: [],
        allProjet: [],
        projet: [],
        listCaisse: [],
        selectSearchProjet: "",
        transRow: [
          {label: 'NE PAS TRANSMETRE', value: 0},
          {label: 'TRANSMETRE', value: 1}
        ],
        ModTransmition: [
          {label: 'MAIL', value: 0},
          {label: 'COURRIER', value: 1}
        ],
        facture: [],
        etape: 0,
        TotalTtc : 0,
        valideRow: [
          {label: 'NON VALIDER', value: 0},
          {label: 'VALIDER', value: 1}
        ],
        formValideF: {
          id: '',
          delegue: 0,
          coordination: 0,
          controle: 0,
          description: '',
          fileList: [{
            name: '',
            url: ''
          }]
        },
        message: {
          code : 0,
          message: ''
        },
        idFacture: '',
        totalRapportF: '0',
        avanceRow: [
          {label: "FACTURE", value: false},
          {label: "FACTURE D'AVANCE", value: true}
        ],
        formProcess: {
          id: '',
          idFac: '',
          entite: '',
          mode: '',
          date: '',
          etat: false,
          description: '',
          fileList: [{
            name: '',
            url: ''
          }]
        },
        modeRow: [
          {label: "MAIL", value: "MAIL"},
          {label: "COURRIER", value: "COURRIER"}
        ],
        etatRow: [
          {label: "EN COURS DE TRAITEMENT", value: false},
          {label: "TERMINE", value: true}
        ],
        listOptions: [],
        option: [],
        idOpFac: '',
      }
    },
    computed: {
    },
    methods: {
      loadClient() {
        this.loading = true
        let url = this.domaine + 'client/projet/index'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listClient = response.body.client
            this.statAllFactureClient = response.body.statsFact
            this.statsPieFacture = response.body.pie
            this.loading = false
            this.statAllFacture()
            this.statAllDiagramCirc()
          }
        }, error => {
            this.loading = false
        })
      },
      loadTravauxSuiviProjet(ligne) {
        this.loading = true;
        let url = this.domaine + "projet/"+ligne+"/index/chantier";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listChantier = response.body.chantier;
            this.loading = false;
          }
        });
      },
      loadProjet(item) {
        this.loading = true
        let url = this.domaine + 'client/projet/'+item.id+'/index'
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listProjet = response.body.projet;
            this.userDetails = item.id;
            this.statDetailClientForOne = response.body.stats;
            this.statsPieFactureForOne = response.body.pieClient;
            this.statForOneClient();
            this.statCircForOneclient();
            this.loading = false;
          }
        }, error => {
            this.loading = false
        })
      },
      loadProjetFacture(ligne) {
        this.loading = true
        let url = this.domaine + "facture/client/"+this.userDetails+"/projet/"+ligne+"/index";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listProjetDetails = response.body
            this.loading = false
          }
        }, error => {
            this.loading = false
        })
      },
      loadCaisse() {
        let url = this.domaine + "caisse/index";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listCaisse = response.body.caisse;
          }
        });
      },
      loadFacture(item) {
        this.loading = true
        let url = this.domaine + "facture/client/"+item.id+"/index";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listFacture = response.body
            this.loading = false
          }
        });
      },
      loadOption(item) {
        this.loading = true
        let url = this.domaine + "facture/client/"+item.id+"/index/process";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listOptions = response.body
            this.loading = false
          }
        });
      },
      findProjet(item) {
        this.loading = true
        let url = this.domaine + "projet/"+item+"/show";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.projet = response.body.projet
            this.loading = false
            this.valideF()
          }
        });
      },
      newClient() {
        this.dialogAjout = true
        this.dialogEdit = false
        this.client = []
        this.form = {
          type: 1,
          libelle: '',
          genre: '',
          situation: '',
          contact: '',
          fixe: '',
          localisation: '',
          adresse: '',
          dateN: '',
          lieuN: '',
          gerant: ''
        }
      },

      newFacture(item) {
        this.dialogFactureAjout = true
        this.message = {}
        this.TotalTtc = 0
        if (item.length !== 0) {
          this.dialogEdit = true
          this.facture = item
          this.formFacture = {
            id: item.id,
            avance: item.avance,
            date: item.date,
            datePaie: item.datePaie,
            dateD: item.dateD,
            dateF: item.dateF,
            montant: item.montant,
            montantAvance: item.montantAvance,
            etat: item.etat,
            caisse: item.idCa,
            description: item.description,
            projet: item.idP
          }
          this.findProjet(item.idP)
          if (!item.avance) {
            this.search()
          }
        } else {
          this.dialogEdit = false
          this.projet = []
          this.formFacture.projet = {}
          this.formFacture = {
            id: '',
            avance: 1,
            date: '',
            datePaie: '',
            montant: 0,
            montantF: '0',
            montantAvance: 0,
            etat: 0,
            caisse: '',
            description: '',
            projet: '',
            dateD: '',
            dateF: '',
            search: []
          }
        }
      },
      newProcess(item){
        this.dialogValidePAjout = true
        this.dialogEdit = false
        this.facture = item
        this.formProcess = {
          id: '',
          idFac: item.id,
          entite: '',
          mode: '',
          date: '',
          etat: false,
          description: ''
        }
      },

      valideFacture(item) {
        this.dialogVaildeFAjout = true
        this.facture = item
        this.etape = 1
        this.formValideF = {
          id: item.id,
          delegue: 0,
          coordination: 0,
          controle: 0,
          description: ''
        }
      },
      edit(item) {
        this.dialogAjout = true
        this.dialogEdit = true
        this.client = item
        this.form = item
        this.form.type = parseInt(item.type)
      },
      show(item) {
        this.dialogShow = true
        this.client = item
      },
      editProcess(item) {
        this.dialogEdit = true
        this.option = item
        this.formProcess = {
          id: item.id,
          idFac: item.idFac,
          entite: item.entite,
          mode: item.mode,
          date: item.date,
          etat: item.etat,
          description: item.description
        }
      },
      showFacture(item) {
        this.dialogFactureShow = true
        this.facture = item
        this.totalRapportF = new Intl.NumberFormat('fr-Fr').format(item.totalRapport)
      },
      formValide() {
        if(this.form.type === 1) {
          if (this.form.civilite !== '' && this.form.libelle !== '' && this.form.contact !== ''
            && this.form.genre !== '') {
            return this.valid = true
          } else {
            return this.valid = false
          }
        } else {
          if (this.form.civilite !== '' && this.form.libelle !== '' && this.form.contact !== ''
            && this.form.genre !== '' && this.form.gerant !== '') {
            return this.valid = true
          } else {
            return this.valid = false
          }
        }
      },
      valideF() {
        let form = this.formFacture
        //avance
        if(this.projet.etatAvance) {
          if (form.date !== '' && form.datePaie !== '' && form.caisse !== '' && form.montantAvance !== 0) {
            return this.valid = true
          } else {
            return this.valid = false
          }
        } else {
          if (form.date !== '' && form.datePaie !== '' && form.caisse !== '' && form.montant !== 0
           && form.dateD !== '' && form.dateF !== '' && form.search.length > 0) {
            return this.valid = true
          } else {
            return this.valid = false
          }
        }
      },
      changeType() {
        let type = this.form.type
        this.form = {
          type: type,
          libelle: '',
          genre: '',
          situation: '',
          contact: '',
          fixe: '',
          localisation: '',
          adresse: '',
          dateN: '',
          lieuN: '',
          gerant: ''
        }
      },
      changeProjet() {
        let idProjet = this.formFacture.projet
        this.formFacture = {
          id: '',
          date: '',
          datePaie: '',
          montant: 0,
          montantF: '0',
          montantAvance: 0,
          etat: 0,
          caisse: '',
          description: '',
          projet: idProjet,
          dateD: '',
          dateF: '',
          search: []
        }
        if (this.formFacture.projet !== '' && this.formFacture.projet !== null) {
          this.findProjet(this.formFacture.projet)
        } else {
          this.projet = []
        }
      },
      search() {
        let url = this.domaine +'facture/client/search'
        var form = document.getElementById('formFacture')
        var data = new FormData(form)
        data.append('projet', this.formFacture.projet)
        data.append('dateD', this.formFacture.dateD)
        data.append('dateF', this.formFacture.dateF)
        this.$http.post(url, data).then(response => {
          if (response.body) {
            this.formFacture.search = response.body.data
            this.formFacture.montant = response.body.total
            this.formFacture.montantF = new Intl.NumberFormat('fr-Fr').format(response.body.total)
            this.message = response.body
            this.$notify.warning({
              title: "RESULTATS",
              message: this.message.message,
              position: 'top-center',
              timeout: 300000
            })
            this.valideF()
          }
        }, response => {

        })
      },
      submit() {
        this.formValide()
        if (this.valid) {
          this.loading = true
          var form = document.getElementById('formClient')
          var data = new FormData(form)
          let url  = ''
          data.append('idUser', this.user.id)
          data.append('type', this.form.type)
          data.append('civilite', this.form.civilite)
          data.append('genre', this.form.genre)
          data.append('situation', this.form.situation)
          if (this.client.id) {
            url = this.domaine +'client/projet/'+ this.client.id + '/edit'
          } else {
            url = this.domaine +'client/projet/new'
          }
          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                if (this.client.id) {
                  this.$notify({
                    title: 'MODIFICATION REUSSI',
                    message: 'Client modifié avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                } else {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Client enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                }

                this.loadClient()
                this.dialogAjout = false
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Le client n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitFacture() {
        this.loading = true
        let formF = this.formFacture
        if (formF.projet !== '' && formF.date !== '' && formF.caisse !== '' &&
         (formF.montantAvance !== 0 || formF.montant !== 0)) {
          var form = document.getElementById('formFacture')
          var data = new FormData(form)
          let url  = ''
          data.append('idUser', this.user.id)
          data.append('id', this.formFacture.id)
          data.append('client', this.client.id)
          data.append('projet', this.formFacture.projet)
          data.append('caisse', this.formFacture.caisse)
          data.append('etat', this.formFacture.etat)
          data.append('avance', this.formFacture.avance)
          data.append('montant', this.formFacture.montant)
          data.append('tva', this.formFacture.tva)
          data.append('totalTtc', this.TotalTtc)
          data.append('transmission', this.formFacture.modeTrans)
          url = this.domaine +'facture/client/new'

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                if (this.formFacture.id) {
                  this.$notify({
                    title: 'MODIFICATION REUSSI',
                    message: 'Facture modifié avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                } else {
                  this.$notify({
                    title: 'ENREGISTREMENT REUSSI',
                    message: 'Facture enregistré avec succès.',
                    type: 'success',
                    position: 'top-center'
                  })
                }

                this.loadFacture(this.client)
                this.dialogFactureAjout = false
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La facture n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitValideF() {
        this.loading = true
        let formF = this.formValideF
        if (formF.delegue !== 0 && formF.coordination !== 0 && formF.controle !== 0) {
          var form = document.getElementById('formValideF')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          data.append('id', formF.id)
          data.append('delegue', formF.delegue)
          data.append('coordination', formF.coordination)
          data.append('controle', formF.controle)
          let url = this.domaine +'facture/client/valider'

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Validation éffectuée avec succès.',
                  type: 'success',
                  position: 'top-center'
                })

                this.loadFacture(this.client)
                this.dialogVaildeFAjout = false
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La validation n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      submitProcess(){
        this.loading = true
        let formF = this.formProcess
        if (formF.idFac !== '' && formF.date !== '' && formF.entite !== '' &&
         formF.mode !== '') {
          var form = document.getElementById('formProcessus')
          var data = new FormData(form)
          let url  = ''
          data.append('idUser', this.user.id)
          data.append('id', this.formProcess.id)
          data.append('facture', this.formProcess.idFac)
          data.append('mode', this.formProcess.mode)
          data.append('etat', this.formProcess.etat)
          url = this.domaine +'facture/client/new/processus'

          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Facture enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                })

                this.loadOption(this.facture)
                this.loadFacture(this.client)
                this.dialogValidePAjout = false
                this.dialogEdit = false
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('Veuillez renseigner les champs obligatoires')
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La facture n'a pas été enregistré.",
            position: 'top-center'
          })
          this.loading = false
        }
      },
      sumbitClose() {
        if (this.facture.etatPross) {
          this.loading = true
          var form = document.getElementById('formProcessus')
          var data = new FormData(form)
          data.append('idUser', this.user.id)
          let url = this.domaine +'facture/client/clore/'+this.facture.id+'/processus'
          this.$http.post(url, data).then(response => {
            if (response.body) {
              let verif = response.body
              if (verif.code === 1) {
                this.$notify({
                  title: 'ENREGISTREMENT REUSSI',
                  message: 'Facture enregistré avec succès.',
                  type: 'success',
                  position: 'top-center'
                })

                this.loadFacture(this.client)
                this.dialogValidePAjout = false
                this.loading = false
              } else if (verif.code === 0) {
                this.$message.error(verif.message)
                this.loading = false
              }
            } else {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
            }
          },
          response => {
            this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.loading = false
          })
        } else {
          this.$message.error('VEUILLEZ TERMINER LE PRECEDENT PROCESSUS DE ENTAMME.')
        }
      },
       calculTotalComm () {

          let montant
          let tva = parseInt( this.formFacture.tva,10)
          let mtnTVA = 0
          let mtnTotal = 0
          if(this.projet.etatAvance && this.formFacture.projet){
              montant = this.formFacture.montantAvance
          }else{
              montant = this.formFacture.montantF
          }
          mtnTotal = parseInt(montant,10) + parseInt(Math.round((montant) * (tva  / 100)),10)
          // this.TotalTtc = new Intl.NumberFormat("fr-FR").format(mtnTotal);
          this.TotalTtc = mtnTotal;
            },
      annulerPross() {
        this.dialogEdit = false
        this.option = []
        this.formProcess = {
          id: '',
          idFac: this.facture.id,
          entite: '',
          mode: '',
          date: '',
          etat: false,
          description: ''
        }
      },
      deleteC(item) {
        let url = this.domaine + "client/projet/delete/" + this.idClient;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Client supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogSupr = false;
            this.loadClient();
          }
        });
      },
      deleteF(item) {
        let url = this.domaine + "facture/client/delete/" + this.idFacture;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Facture supprimé avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogFactureSupr = false;
            this.loadFacture(this.client);
          }
        });
      },
      deleteOF() {
        let url = this.domaine + "facture/client/process/delete/" + this.idOpFac;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.$notify({
              title: "SUPPRESSION",
              message: "Supression éffectuée avec succès.",
              type: "success",
              position: "top-center"
            });
            this.dialogValidePSupr = false;
            this.loadOption(this.facture);
            this.loadFacture(this.client)
            this.dialogValidePAjout = false
          }
        });
      },
      handleRemove(file, fileList) {},
      handlePreview(file) {
        this.formValideF.fileList = file
      },
      statAllDiagramCirc () {
          //commande livre et commande effectue
          let optionComm = {
              title: {
                  text: 'Facture(Payée, Impayée,En cours,En attente)',
                  subtext: '',
                  left: 'center'
              },
              tooltip : {
                  trigger: 'item',
                  formatter: "{a} <br/>{b} : {c} ({d}%)"
              },
              legend: {
                  bottom: 10,
                  left: 'left',
                  data: ['Facture payée', 'Facture impayée','Facture en cours','Facture en attente']
              },
              series : [
                  {
                      type: 'pie',
                      radius : '65%',
                      center: ['50%', '50%'],
                      selectedMode: 'single',
                      data:[
                          { value: this.statsPieFacture.paye, name: 'facture payée'},
                          { value: this.statsPieFacture.impaye, name: 'facture impayée'},
                          { value: this.statsPieFacture.enCours, name: 'facture en cours'},
                          { value: this.statsPieFacture.attente, name: 'facture en attente'},
                      ],
                      itemStyle: {
                          emphasis: {
                              shadowBlur: 10,
                              shadowOffsetX: 0,
                              shadowColor: 'rgba(0, 0, 0, 0.5)'
                          }
                      }
                  }
              ]
          }
          let chartClientAll = echarts.init(document.getElementById('chartClientAll'))
                chartClientAll.setOption(optionComm)
      },
      statAllFacture () {
          //facture paye et impaye
          let optionFactAll = {
              title: {
                  text: 'Facture payée et impayée',
                  subtext: '',
                  left: 'center'
              },
              color: ['#e5323e', '#67C23A'],
              tooltip : {
                  trigger: 'axis',
                  axisPointer : {
                      type : 'shadow'
                  }
              },
              legend: {
                  data:[]
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis : [{
                  type : 'category',
                  data : []
              }],
              yAxis : [{ type : 'value' }],
              series : [
                  {
                      name:'Impayé',
                      type:'bar',
                      barWidth : 5,
                      data:[]
                  },
                  {
                      name:'Payé',
                      type:'bar',
                      barWidth : 5,
                      data:[]
                  }
              ]
          }

          this.statAllFactureClient.forEach(function(element) {
              optionFactAll.xAxis[0].data.push(element.date);
              optionFactAll.series[0].data.push(element.impaye)
              optionFactAll.series[1].data.push(element.paye)
          })

          let chartFactureAllClient = echarts.init(document.getElementById('chartFactureAllClient'))
          chartFactureAllClient.setOption(optionFactAll)
      },
      statCircForOneclient () {
          //commande livre et commande effectue
          let optionComm = {
              title: {
                  text: 'Facture(Payée, Impayée,En cours,En attente)',
                  subtext: '',
                  left: 'center'
              },
              tooltip : {
                  trigger: 'item',
                  formatter: "{a} <br/>{b} : {c} ({d}%)"
              },
              legend: {
                  bottom: 10,
                  left: 'left',
                  data: ['Facture payée', 'Facture impayée','Facture en cours','Facture en attente']
              },
              series : [
                  {
                      type: 'pie',
                      radius : '65%',
                      center: ['50%', '50%'],
                      selectedMode: 'single',
                      data:[
                          { value: this.statsPieFactureForOne.paye, name: 'facture payée'},
                          { value: this.statsPieFactureForOne.impaye, name: 'facture impayée'},
                          { value: this.statsPieFactureForOne.enCours, name: 'facture en cours'},
                          { value: this.statsPieFactureForOne.attente, name: 'facture en attente'},
                      ],
                      itemStyle: {
                          emphasis: {
                              shadowBlur: 10,
                              shadowOffsetX: 0,
                              shadowColor: 'rgba(0, 0, 0, 0.5)'
                          }
                      }
                  }
              ]
          }
          let chartForOneClient = echarts.init(document.getElementById('chartForOneClient'))
                chartForOneClient.setOption(optionComm)
      },
      statForOneClient () {
          //facture paye et impaye
          let optionFactAll = {
              title: {
                  text: 'Facture payée et impayée',
                  subtext: '',
                  left: 'center'
              },
              color: ['#e5323e', '#67C23A'],
              tooltip : {
                  trigger: 'axis',
                  axisPointer : {
                      type : 'shadow'
                  }
              },
              legend: {
                  data:[]
              },
              grid: {
                  left: '3%',
                  right: '4%',
                  bottom: '3%',
                  containLabel: true
              },
              xAxis : [{
                  type : 'category',
                  data : []
              }],
              yAxis : [{ type : 'value' }],
              series : [
                  {
                      name:'Impayé',
                      type:'bar',
                      barWidth : 5,
                      data:[]
                  },
                  {
                      name:'Payé',
                      type:'bar',
                      barWidth : 5,
                      data:[]
                  }
              ]
          }

          this.statDetailClientForOne.forEach(function(element) {
              optionFactAll.xAxis[0].data.push(element.date);
              optionFactAll.series[0].data.push(element.impaye)
              optionFactAll.series[1].data.push(element.paye)
          })

          let chartFactureForOneClient = echarts.init(document.getElementById('chartFactureForOneClient'))
          chartFactureForOneClient.setOption(optionFactAll)
      },
    },
    mounted () {
      this.loadClient();
      this.loadCaisse();
    },
    beforeMount: function () {
      // if(!this.roleAcces[this.$router.history.current.name]){
      //   this.$router.push({ name: 'Home'  })
      // }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/Client.vue